import { render } from "./takat-left-collection.vue?vue&type=template&id=5ff265dc&scoped=true"
import script from "./takat-left-collection.vue?vue&type=script&lang=js"
export * from "./takat-left-collection.vue?vue&type=script&lang=js"

import "./takat-left-collection.vue?vue&type=style&index=0&id=5ff265dc&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff265dc"]])

export default __exports__